import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnDestroy, OnInit } from '@angular/core';

import { BaseComponent } from '../../../core/abstractions/base.component';
import { DmiStatusModel } from '../../../models/dmi-status.model';
import { GateResource } from '../../../services/resources/gate.resource';

@Component({
    selector: 'sl-dmi-status-indicator',
    templateUrl: './dmi-status-indicator.component.html',
    styleUrls: ['./dmi-status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DmiStatusIndicatorComponent extends BaseComponent implements OnInit, OnDestroy {
    isDmiStatusLoading = true;
    dmiStatus?: DmiStatusModel;
    dmiStatusClass: string;

    readonly statusChanged = new EventEmitter<DmiStatusModel>();

    private intervalId: NodeJS.Timeout;
    private readonly gateResource = inject(GateResource);

    ngOnInit(): void {
        this.intervalId = setInterval(() => this.checkStatus(), 30000);
        this.checkStatus();
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        clearInterval(this.intervalId);
    }

    private checkStatus(): void {
        this.gateResource.getStatus().subscribe(status => {
            this.isDmiStatusLoading = false;
            this.dmiStatus = status.value;
            this.dmiStatusClass = this.getDmiStatusClass(this.dmiStatus.status);

            this.statusChanged.emit(this.dmiStatus);
        });
    }

    private getDmiStatusClass(status?: boolean): string {
        if (status === true) {
            return 'dmi-available';
        } else if (status === false) {
            return 'dmi-not-available';
        } else {
            return 'dmi-unknown';
        }
    }
}
